import _classCallCheck from "/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { __decorate } from "tslib";
import { FrequencyClass } from "../core/type/Frequency";
import { deepMerge, optionsFromArguments } from "../core/util/Defaults";
import { readOnly } from "../core/util/Interface";
import { Monophonic } from "./Monophonic";
import { Synth } from "./Synth";
import { range, timeRange } from "../core/util/Decorator";
/**
 * MembraneSynth makes kick and tom sounds using a single oscillator
 * with an amplitude envelope and frequency ramp. A Tone.OmniOscillator
 * is routed through a Tone.AmplitudeEnvelope to the output. The drum
 * quality of the sound comes from the frequency envelope applied
 * during MembraneSynth.triggerAttack(note). The frequency envelope
 * starts at <code>note * .octaves</code> and ramps to <code>note</code>
 * over the duration of <code>.pitchDecay</code>.
 * @example
 * const synth = new Tone.MembraneSynth().toDestination();
 * synth.triggerAttackRelease("C2", "8n");
 * @category Instrument
 */
export var MembraneSynth = /*#__PURE__*/function (_Synth) {
  _inherits(MembraneSynth, _Synth);
  var _super = _createSuper(MembraneSynth);
  function MembraneSynth() {
    var _this;
    _classCallCheck(this, MembraneSynth);
    _this = _super.call(this, optionsFromArguments(MembraneSynth.getDefaults(), arguments));
    _this.name = "MembraneSynth";
    /**
     * Portamento is ignored in this synth. use pitch decay instead.
     */
    _this.portamento = 0;
    var options = optionsFromArguments(MembraneSynth.getDefaults(), arguments);
    _this.pitchDecay = options.pitchDecay;
    _this.octaves = options.octaves;
    readOnly(_assertThisInitialized(_this), ["oscillator", "envelope"]);
    return _this;
  }
  _createClass(MembraneSynth, [{
    key: "setNote",
    value: function setNote(note, time) {
      var seconds = this.toSeconds(time);
      var hertz = this.toFrequency(note instanceof FrequencyClass ? note.toFrequency() : note);
      var maxNote = hertz * this.octaves;
      this.oscillator.frequency.setValueAtTime(maxNote, seconds);
      this.oscillator.frequency.exponentialRampToValueAtTime(hertz, seconds + this.toSeconds(this.pitchDecay));
      return this;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(MembraneSynth.prototype), "dispose", this).call(this);
      return this;
    }
  }], [{
    key: "getDefaults",
    value: function getDefaults() {
      return deepMerge(Monophonic.getDefaults(), Synth.getDefaults(), {
        envelope: {
          attack: 0.001,
          attackCurve: "exponential",
          decay: 0.4,
          release: 1.4,
          sustain: 0.01
        },
        octaves: 10,
        oscillator: {
          type: "sine"
        },
        pitchDecay: 0.05
      });
    }
  }]);
  return MembraneSynth;
}(Synth);
__decorate([range(0)], MembraneSynth.prototype, "octaves", void 0);
__decorate([timeRange(0)], MembraneSynth.prototype, "pitchDecay", void 0);